import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './SearchForm.css';

class SearchForm extends React.Component {

  constructor() {
    super();

    this.handleForm = this.handleForm.bind(this);
  }

  handleForm(e) {
    e.preventDefault();
    this.props.updateQuery(this.refs.searchTerm.value);
  }

  render() {
    const uId = _.uniqueId('search-input_');
    return (
      <section className="searchForm">
        <p className="sr-only">Please submit a search query to view search results from CBC.ca</p>
        <form onSubmit={this.handleForm}>
          <label htmlFor={uId} className="sr-only">Search</label>
          <input
            ref="searchTerm"
            type="search"
            id={uId}
            placeholder=""
            defaultValue={this.props.searchTerm}
          />
          <input type="image" name="btnG" src="//www.cbc.ca/gsa/i/gfx/search.gif" width="60" height="26" value="Search" alt="Submit search" />
        </form>
      </section>
    );
  }
}

export default SearchForm;

SearchForm.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  updateQuery: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/SearchForm.js